import React, { useEffect, useState } from "react";

export default function Dashboard() {

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchUser = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                setError("No token found. Please login.");
                setLoading(false);
                return;
            }

            try {
                const res = await fetch("http://localhost:8080/api/auth/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });

                const data = await res.json();
                if (!res.ok) throw new Error(data.message || "Failed to fetch user");

                setUser(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    if (loading) return <p>Loading user info...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;


    return (
        <div>
            <h1 className="text-2xl font-bold mb-4">Welcome to the Dashboard</h1>
            <p>This is your admin overview page.</p>

            <div style={{ padding: "20px", border: "1px solid #ccc", width: "300px" }}>
                <h2>User Profile</h2>
                <p><strong>ID:</strong> {user._id}</p>
                <p><strong>Name:</strong> {user.name}</p>
                <p><strong>Email:</strong> {user.email}</p>
                <p><strong>Role:</strong> {user.role}</p>
                <p><strong>Created At:</strong> {new Date(user.createdAt).toLocaleString()}</p>
            </div>
        </div>
    );
}
